import { BasicItemResponse } from "../../../../responses/basicResponses";
import { CustomPanelTypeStatus, ICustomZShapeType } from "../../../../responses/customPanelTypes";
import repo from "../../../../Repository";

export class CustomZShapedTypeUploader {
    async uploadCustomComponent(file: File, assemblyFileName: string): Promise<BasicItemResponse<ICustomZShapeType>> {
        const createNewCustomComponentResponse = await repo.createCustomZShapedType(file.name);

        if (!createNewCustomComponentResponse.isSuccess) {
            return { isSuccess: false, message: createNewCustomComponentResponse.message, item: null };
        }

        const { id, uploadUrl } = createNewCustomComponentResponse.item;

        const uploadFileResult = await repo.uploadFile(file, uploadUrl);

        if (!uploadFileResult.isSuccess) {
            return { isSuccess: false, message: uploadFileResult.message, item: null };
        }

        const startComponentProcessingResponse = await repo.startCustomZShapedTypeProcessing(id, assemblyFileName);

        if (!startComponentProcessingResponse.isSuccess) {
            return { isSuccess: false, message: startComponentProcessingResponse.message, item: null };
        }

        return this.waitForProcessingDone(id);
    }

    private waitForProcessingDone(id: string): Promise<BasicItemResponse<ICustomZShapeType>> {
        return new Promise<BasicItemResponse<ICustomZShapeType>>(resolve => {
            const timeout = 5000;

            const periodicalCheck = async () => {
                const response = await repo.findCustomZShapedType(id);

                if (!response.isSuccess || response.item.status === CustomPanelTypeStatus.Created) {
                    setTimeout(periodicalCheck, timeout);

                    return;
                }

                resolve(response);
            };

            setTimeout(periodicalCheck, timeout);
        });
    }
}
